import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { money } from "../lib/api";

const tints = ["var(--yellow)", "var(--cyan)", "var(--pink)", "var(--lime)", "var(--orange)"];

export const ProductCard = ({ p, i, onOpen, onAdd }) => (
  <motion.article layout initial={{ opacity: 0.001, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    data-testid={`product-card-${p.slug}`} className="group">
    <button onClick={() => onOpen(p)} data-testid={`product-open-${p.slug}`}
      className="relative block w-full aspect-square rounded-[18px] sm:rounded-[26px] chunk-sm sm:chunk overflow-hidden text-left" style={{ background: tints[i % tints.length] }}>
      <div className="absolute inset-2 sm:inset-5 rounded-[12px] sm:rounded-[18px] overflow-hidden border-2 border-[var(--ink)] [clip-path:inset(0_round_12px)] sm:[clip-path:inset(0_round_18px)]">
        <img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
      </div>
      {p.badge && (
        <span className="hidden sm:inline absolute top-7 left-7 px-3 py-1 rounded-full bg-white chunk-sm font-mono-x text-[11px] uppercase tracking-widest font-bold">{p.badge}</span>
      )}
      <span className="absolute bottom-3.5 right-3.5 sm:bottom-7 sm:right-7 px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-full bg-[var(--ink)] text-[var(--paper)] font-mono-x text-xs sm:text-sm font-bold" data-testid={`product-price-${p.slug}`}>
        {money(p.price)}
      </span>
    </button>
    <div className="flex items-start justify-between gap-2 sm:gap-3 pt-3 sm:pt-5 px-0.5 sm:px-1">
      <div className="min-w-0">
        <p className="font-mono-x text-xs uppercase tracking-[0.12em] sm:tracking-[0.16em] text-[#5a5470] truncate">{p.category}</p>
        <h3 className="font-display font-extrabold text-base sm:text-2xl tracking-tight mt-1 leading-tight">{p.name}</h3>
      </div>
      <button data-testid={`product-add-${p.slug}`} onClick={() => onAdd(p)} aria-label={`Add ${p.name} to cart`}
        className="shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[var(--pink)] text-white chunk-sm press grid place-items-center">
        <Plus className="w-5 h-5" />
      </button>
    </div>
  </motion.article>
);
